export default __webpack_public_path__ + "static/media/sql-server.c32ac924.png";